export default __webpack_public_path__ + "static/media/tierfreunde_14.ca0af998.jpg";